import React from "react";
import { Outlet, useMatch } from "react-router";
import UnitList from "./components/UnitList";

const UnitsScreen = () => {
    const match = useMatch("/supervising/units/:unitId");
    const hasSelection = !!match;

    return (
        <div className="flex min-h-0 flex-1">
            <section
                className={[
                    "min-h-0 flex-col overflow-hidden bg-surface",
                    hasSelection
                        ? "hidden lg:flex lg:w-[22rem] lg:shrink-0 lg:border-r lg:border-border xl:w-[26rem]"
                        : "flex flex-1",
                ].join(" ")}
            >
                <UnitList />
            </section>
            {hasSelection && (
                <section className="flex min-h-0 min-w-0 flex-1 overflow-hidden">
                    <Outlet />
                </section>
            )}
        </div>
    );
};

export default UnitsScreen;
